(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["nioJsBridge"] = factory();
	else
		root["nioJsBridge"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(3)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4),
    isObject = __webpack_require__(2);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4),
    isArray = __webpack_require__(6),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(11);

var nextMonth = new Date(new Date().setMonth(new Date().getMonth() + 1)); // 跨年会不会有影响
/**
 *
 * @description 存储使用
 *  lei.you
 */
var expire = nextMonth.getTime();
exports.default = {
  /**
   * @param {object} context :{
   *   data:{
   *    key：xxxxx 必填
   *    value : xxx 必填
   *
   *  }
   * }
   * @return {void}
   */
  set: function set(context) {
    _util.util.checker(context);
    context.data.expire = new Date(context.data.expire || expire).getTime();
    //context.data.expire = 10000;
    _util.util.getDsBridge().call('setStorageValue', context.data);
  },

  /**
   * @param {object} context :{
   *   data:{
   *      key:'' // 必填
   *  }
   * }
   * @return {void}
   */
  get: function get(context) {
    _util.util.checker(context);
    var result = _util.util.getDsBridge().call('getStorageValue', context.data.key);
    delete result.expire;
    return result;
  },

  /**
   * @param {object} context :{
   *   data:{
   *      key:''
   *  }
   * }
   * @return {void }
   */
  remove: function remove(context) {
    _util.util.checker(context);
    _util.util.getDsBridge().call('removeStorage', context.data.key);
  },

  /**
   * @param {object} context :{
   *   data:{
   *      key:''
   *  }
   * }
   * @return {void}
   */
  delete: function _delete(context) {
    _util.util.checker(context);
    _util.util.getDsBridge().call('removeStorage', context.data.key);
  },

  /**
   * @description 清除所有 慎用，会把app 存储没有domian概念会导致全部清除
   * @return {void}
   */
  clear: function clear() {
    _util.util.getDsBridge().call('clearStorage', '');
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.util = undefined;

var _isFunction2 = __webpack_require__(7);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isString2 = __webpack_require__(9);

var _isString3 = _interopRequireDefault(_isString2);

var _has2 = __webpack_require__(27);

var _has3 = _interopRequireDefault(_has2);

var _isObject2 = __webpack_require__(2);

var _isObject3 = _interopRequireDefault(_isObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var util = {
  isStandardInputParam: function isStandardInputParam(context) {
    if ((0, _isObject3.default)(context)) {
      if ((0, _has3.default)(context, 'data') || (0, _has3.default)(context, 'event') || (0, _has3.default)(context, 'callback')) {
        return true;
      }
    }
    return false;
  },

  // eslint-disable-next-line valid-jsdoc
  /**
   @description 类型参数检测器
     @param {
       data :{
      }
      event:"",
      callback:e=>{
   
      }
    } context
    
    @return {void}
   */
  checker: function checker(context) {
    if (context !== undefined) {
      if (!(0, _isObject3.default)(context)) {
        var e = new Error('error info:  error param type ， need object has context.data or context.callback or context.event');
        throw e;
      }
      if (context.data !== undefined) {
        if (!(0, _isObject3.default)(context.data)) {
          var _e = new Error("error info:  context.data type need Object");
          throw _e;
        }
      }
      if (context.event !== undefined) {
        if (!(0, _isString3.default)(context.event)) {
          var _e2 = new Error("error info:  context.event type need String");
          throw _e2;
        }
      }
      if (context.callback !== undefined) {
        if (!(0, _isFunction3.default)(context.callback)) {
          var _e3 = new Error("error info:  context.callback type need Function");
          throw _e3;
        }
      }
    }
  },
  getDsBridge: function getDsBridge() {
    var dsBridge = window['dsBridge'];
    return dsBridge;
  }
};

exports.util = util;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(34);
var IE8_DOM_DEFINE = __webpack_require__(35);
var toPrimitive = __webpack_require__(37);
var dP = Object.defineProperty;

exports.f = __webpack_require__(5) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constant = exports.storage = exports.nioJsBridge = undefined;

var _jsbridge = __webpack_require__(16);

var _jsbridge2 = _interopRequireDefault(_jsbridge);

var _storage = __webpack_require__(10);

var _storage2 = _interopRequireDefault(_storage);

var _constant = __webpack_require__(28);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var constant = _constant2.default.constant;
exports.nioJsBridge = _jsbridge2.default;
exports.storage = _storage2.default;
exports.constant = constant;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(17);

var _stringify2 = _interopRequireDefault(_stringify);

var _isInteger2 = __webpack_require__(19);

var _isInteger3 = _interopRequireDefault(_isInteger2);

var _isArray2 = __webpack_require__(6);

var _isArray3 = _interopRequireDefault(_isArray2);

var _isFunction2 = __webpack_require__(7);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isNumber2 = __webpack_require__(26);

var _isNumber3 = _interopRequireDefault(_isNumber2);

var _isString2 = __webpack_require__(9);

var _isString3 = _interopRequireDefault(_isString2);

var _isObject2 = __webpack_require__(2);

var _isObject3 = _interopRequireDefault(_isObject2);

var _storage = __webpack_require__(10);

var _storage2 = _interopRequireDefault(_storage);

var _util = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description 对底层util.getDsBridge() 的统一封装，暴露统一接口给前端开发使用
 * @author lei.you
 * 
 * url说明
    例如如下url：
    file:///android_asset/testnew.html?is_nav_show=true&title=iamtitle&is_jack_up=true
    is_nav_show: true || false
    is_loading:true 
    title：表示导航栏中间标题
    is_jack_up ：是否支持键盘顶起h5 默认是支持顶起
 */

exports.default = {
  storage: _storage2.default,

  /**
   * @description showToast
   * @param {object|string} context{
   *     data:{
   *        content:'xxxx' //required
   *     }
   * } || Object || String content
   *
   * @return {void} 无返回
   */
  showToast: function showToast(context) {
    var toastTxt = void 0;
    if (_util.util.isStandardInputParam(context)) {
      toastTxt = context.data.content;
      if ((0, _isObject3.default)(toastTxt)) {
        toastTxt = (0, _stringify2.default)(toastTxt);
      }
    } else {
      if ((0, _isObject3.default)(context)) {
        toastTxt = (0, _stringify2.default)(context);
      }
      if ((0, _isString3.default)(context)) {
        toastTxt = context;
      }
    }
    _util.util.getDsBridge().call('showToast', toastTxt);
  },

  /**
   *@description showLoading
    @param {object|string|null} context{
    data:{
          content:'xxxx'
        }
    } | string content  
   * @return {void} 无返回
   */
  showLoading: function showLoading(context) {
    if (!context) {
      context = "";
    }
    if ((0, _isObject3.default)(context)) {
      _util.util.checker(context);
    }
    _util.util.getDsBridge().call('showLoading', (0, _isString3.default)(context) ? context : context.data.content);
  },

  /**
   * @description hideLoading
   * @return {void} 无返回
   */
  hideLoading: function hideLoading() {
    _util.util.getDsBridge().call('hideLoading', '');
  },

  /**
   * @description 关闭软键盘
   * @return {void} 无返回
   */
  closeKeyboard: function closeKeyboard() {
    _util.util.getDsBridge().call('closeKeyboard', '');
  },

  /**
   * @description 拨打电话
   * @param  {object|string}  context {
   *   data:{
   *     tel:xxx //required
   *   }，
   *   event:""
   *   callback:funciton(){
   *   }
   * }
   *
   * @return {void} 无返回
   */
  makeCall: function makeCall(context) {
    if ((0, _isObject3.default)(context)) {
      _util.util.checker(context);
    }
    _util.util.getDsBridge().call('makeCall', (0, _isString3.default)(context) ? context : context.data.tel);
  },

  /**
   *  @description  把内容放到剪切板
   * @param {object|string} context {
   *  data:{
   *    content:'' //required
   *  }
   * }
   * @return {string} 返回文字内容
   */
  setCopyText: function setCopyText(context) {
    if ((0, _isObject3.default)(context)) {
      _util.util.checker(context);
    }
    return _util.util.getDsBridge().call('setCopyText', (0, _isString3.default)(context) ? context : context.data.content);
  },

  /**
   * @param {object | number} context {
   *    data:{
   *       type:0  1 刷新 0 禁止
   *    }
   * }
   * @description 下拉刷新
   * @return {void} 无返回
   *
   */
  pullRefresh: function pullRefresh(context) {
    if ((0, _isObject3.default)(context)) {
      _util.util.checker(context);
    }
    // 参数`1`为启用下拉刷新，`0`为禁止下拉刷新xxx
    _util.util.getDsBridge().call('isShowPullRefresh', (0, _isNumber3.default)(context) ? context : context.data.type);
  },

  /**
   * @returns {object} appInfo
   */
  getAppInfo: function getAppInfo() {
    return _util.util.getDsBridge().call('getAppInfo', '');
  },

  /**
   * @returns {object} userInfo
   */
  getUserInfo: function getUserInfo() {
    return _util.util.getDsBridge().call('getUserInfo', '');
  },

  /**
   * @returns {object} osInfo
   */
  getOSInfo: function getOSInfo() {
    return _util.util.getDsBridge().call('getOSInfo', '');
  },

  /**
   * @returns {object} vhicleInfo
   */
  getVhicleInfo: function getVhicleInfo() {
    return _util.util.getDsBridge().call('getVhicleInfo', '');
  },

  /**
   *
   * @description  获取应用是否开启通知
   * @param {object} context{
      callback:function(){
        }
   * }
   * @return {false} 是否代开
   */
  getNotificationSettings: function getNotificationSettings(context) {
    if ((0, _isObject3.default)(context)) {
      _util.util.checker(context);
    } else {
      var e = new Error("context need Object like {callback:function(){ } }");
      throw e;
    }
    return _util.util.getDsBridge().call('isNotificationEnabled', function (result) {
      if ((0, _isFunction3.default)(context.callback)) {
        context.callback(result);
      }
    });
  },

  /**
   * @description  获取地理定位
   * @param {object} context {
   *  callback : function(){}
   * }
   * @return {object} 返回经纬度
   *  callback: ({
   *     isInvalid, //是否可获取
   *     latitude, //纬度
   *     longitude, //经度
   *     city, // 城市名称
   *     cityCode // 城市编码
   *   }) => {}
   *
   */
  getLocation: function getLocation(context) {
    _util.util.checker();
    return _util.util.getDsBridge().call('getLocation', '', function (result) {
      context.callback(result);
    });
  },

  /**
   * @description  打开通知设置
   * @return {void} 无返回
   */
  openNotificationSetting: function openNotificationSetting() {
    _util.util.getDsBridge().call('goToSetNotification', '');
  },

  /**
   // eslint-disable-next-line valid-jsdoc
     @param context  {object | number} context {
       data:{
          type:0  1 允许 0 禁止
       }
    } 
    * @description  允许ios 使用webview 的皮筋效果
    * @return {void} 无返回
    */
  iosAllowPull: function iosAllowPull(context) {
    _util.util.getDsBridge().call('goToSetNotification', context.data.type);
  },

  /**
   * @description ios 启用滑动退出;
   * @return {void} 无返回
   */
  iosAllowsBackForwardNavigationGestures: function iosAllowsBackForwardNavigationGestures() {
    // 启用
    _util.util.getDsBridge().call('allowsBackForwardNavigationGestures', '');
  },

  /**
   * @description 打开地图
   * @param {object} context{
   *   data:{
   *      latitude: '',
   *      longitude: '',
   *      addressName: ''
   *   }
   * }
   * @return {void} 无返回
   */
  openMap: function openMap(context) {
    _util.util.checker(context);
    _util.util.getDsBridge().call('openMap', context.data);
  },

  /**
   * @description ios 禁用滑动退出;
   * @return {void} 无返回
   */
  iosDisableBackForwardNavigationGestures: function iosDisableBackForwardNavigationGestures() {
    // 禁止
    _util.util.getDsBridge().call('disableBackForwardNavigationGestures', '');
  },

  /**
   * @description  (iOS) 取消系统默认键盘响应
   * @return {void} 无返回
   */
  iosDisableIOSSystemKeyboardObserver: function iosDisableIOSSystemKeyboardObserver() {
    _util.util.getDsBridge().call('disableSystemKeyboardObserver', '');
  },

  /**
   * @description 展示国家选择器
   * @param {object} context {
   *   data: {
   *     context: '' // 默认选择区域码
   *   }
   *   callback: funciton({
   *     data: {
   *       abbrOfCounty, callingCode, fullName, group, lang, region
   *     },
   *     result_code: ''
   *   }){}
   * }
   * @return {object} 返回选择内容
   */
  showCountries: function showCountries(context) {
    _util.util.checker(context);
    var url = 'nioapp://user/countries' + (context.data.content ? '?callingCode=' + context.data.content : '');
    _util.util.getDsBridge().call('openURL', url, function (result) {
      if ((0, _isFunction3.default)(context.callback)) {
        context.callback(result);
      }
    });
  },

  /**
   * @description 下载视频
   * @param {object} context {
   *   data: {
   *     video_url: '' //视频下载地址
   *   }
   *   callback: funciton({result: 'success'}){}
   * }
   * @return {void} 异步返回
   */
  downloadVideo: function downloadVideo(context) {
    _util.util.checker(context);
    _util.util.getDsBridge().call('videoDownload', context.data, function (result) {
      context.callback && context.callback(result);
    });
  },

  /**
   * @description  获取本地图片相册&获取拍照图片
   * @param {object} context {
   *   callback: funciton({result: 'success', content: {base64: '', imagePath: ''}}){}
   * }
   * @return {void} 异步返回
   */
  imagePicker: function imagePicker(context) {
    _util.util.checker(context);
    _util.util.getDsBridge().call('imagePicker', '', function (result) {
      context.callback(result);
    });
  },

  /**
   * @description  保存图片至本地相册，支持多选
   * @param {object} context {
   *   data: {
   *     base64Images: [] // image base64 字符数组
   *     urls:[] // 在线url 地址保存图片
   *   }
   *   callback: funciton({result: 'success'}){}
   * }
   * @return {void} 异步返回
   */
  saveImage: function saveImage(context) {
    _util.util.checker(context); // _.isString(context) ? context : context.data.url
    var arr = (0, _isArray3.default)(context) ? context : context.data;
    _util.util.getDsBridge().call('savePhotosAlbum', arr, function (result) {
      context.callback && context.callback(result);
    });
  },

  /**
   * @description 图片预览
   * @param {object} context {
   * data:{
   *  "urls": ["https://static.macflow.net/wp-content/uploads/2018/03/kantu.jpg",
              "https://img.iplaysoft.com/wp-content/uploads/2017/unsplash/unsplash_image.jpg"
              ],
      "position": 1
   * }
     
    }
   
      @return {void} 无返回
   */
  previewPhoto: function previewPhoto(context) {
    _util.util.checker(context);
    _util.util.getDsBridge().call('previewPhoto', context.data);
  },

  /**
   * @description 扫码
   * @param {object} context {
   *   callback:function(result){
   *   }
   * }
   *  @return {void} 异步返回
   */
  scanQR: function scanQR(context) {
    _util.util.checker(context);
    _util.util.getDsBridge().call('scanQR', function (result) {
      context.callback(result);
    });
  },

  /**
   * @description 关闭本页面
   *  @return {void} 无返回
   */
  close: function close() {
    _util.util.getDsBridge().call('close');
  },


  /**
   * @description  设置头部参数
   @param {object } context {
   
    data :{
    isShow:true,  // 头部隐藏或者显示  ** 新增
    color: #xxx  // 颜色默认透明沉浸式  ** 新增
    title:{ //标题文字为 标题，颜色为 #AA00AA，无图标，文字居中
        text: "标题",
        textColor: "AA00AA",
        icon:{
            position:"left", 
            url: null
        },
        callback: "onTitle"
    },
    leftColumn: null, // 木有左侧自定义按钮，只有一个返回按钮
    rightColumn: [{ // 两个右侧自定义按钮
        text: "标题", // 文字为 标题，颜色为 #AAAAAA，木有图标，文字居中
        textColor: "AAAAAA",
        icon: null,
        callback:"onCustom"
    },{
        text: "标题",// 文字为 标题，颜色为 #AAAAAA，有图标，字左图右
        textColor: "AAAAAA",
        icon:{
            position:"right", // left right
            url:"https://www.kavo.co.jp/wp-content/themes/twentyeleven3/image/icon_facebook.jpg"
        },
        callback:"onCustom"
    }]
  }
    
   }
   
    @return {void} 无返回
   
   */
  setHeaderOption: function setHeaderOption(context) {
    _util.util.checker(context);
    _util.util.getDsBridge().call('headerSetOption', context.data);
  },

  /**
   *@description  打开登录页
    @param {object} context{
      callback:function(){
        
      }
    }
     @return {void} 无
   */
  openLoginPage: function openLoginPage(context) {
    _util.util.getDsBridge().call('openURL', 'nioapp://user/requirelogin', function (string) {
      if (context.callback) {
        context.callback(string);
      }
    });
  },

  /**
   * @description  打开新页面
   * @param {object|string} context{
   *   data:{
   *     url：xxxxx
   *   },
   *   callback(){
   *   }
   * }
   * @return {object} 异步返回
   *
   */
  openURL: function openURL(context) {

    console.log(context);
    if ((0, _isObject3.default)(context)) {
      _util.util.checker(context);
    }
    var url = (0, _isString3.default)(context) ? context : context.data.url;
    _util.util.getDsBridge().call('openURL', url, function (result) {
      if ((0, _isFunction3.default)(context.callback)) {
        context.callback(result);
      }
    });
  },


  /**
  * @description  打开新页面
  * @param {object|integer} context{
  *   data:{
  *     step:1, //required
  *   } 
  * }
  * @return {void}  
  */
  back: function back(context) {
    if ((0, _isObject3.default)(context)) {
      _util.util.checker(context);
    }

    var step = (0, _isInteger3.default)(context) ? context : context.data.step;
    if (!((0, _isNumber3.default)(step) && (0, _isInteger3.default)(step) && step > 0)) {
      var e = new Error("if context is integer need gt 0");
      throw e;
    }
    _util.util.getDsBridge().call('goBack', step.toString());
  },

  /**
   * @description 支付
   * @param {object} context 
     {
       data: {
        userID: "",
        amount: "",
        orderNO: "",
        subject: "",
        body: "body",
        businessType: "vom"
      },
      callback(){
      
      }
    }
    @return {object} 支付结果
   */
  pay: function pay(context) {
    _util.util.checker(context);
    _util.util.getDsBridge().call('pay', context.data, function (result) {
      context.callback(result);
    });
  },

  /**
   * @description 分享
   * @param {object} context {
      data :{
        title: "分享标题",
        subtitle: "分享内容描述",
        imgUrl: "https://...",
        urlScheme: "https://...",
        type: ["wx", "timeline", "nio"], // 可不传，默认 ["wx", "timeline", "wb", "nio"]
        miniData: { // 可不传，默认 nil。miniData 为 nil 或不合规时分享微信将会是传统的分享
            title: "小程序标题",
            description: "小程序内容描述",
            thumImage: "https://...",
            hdImage: "https://...",
            webpageUrl: "https://...",
            userName: "wx8b7897772a8449ba",
            path: "pages/index",
            bitmap: "https://...", // 可不传，默认 nil，分享给朋友圈将会是传统的分享
            withShareTicket: false, // 可不传，默认 false
            programType: "release" // 可不传，默认 release
          }
        },
    callback:function(result) {
        {
        "plat": "niofriend/weibo/wechatfriend/wechatcircle",
        "result": "success/fail/cancel"
      }
    }
    * }
    var arg = {
      "title": "I am title",
      "subTitle": "我是sub title",
      "imgUrl":"https://www.nio.cn/cdn-static/mynio/images/about/about-hero-desktop.jpg",
      "url":"https://l.nio.com/s/qGdSNjWRi4",
      "type":["facebook","messenger","twitter"]
    }
       
   * @return {object} 分享结果
   */
  share: function share(context) {
    _util.util.checker(context);
    _util.util.getDsBridge().call('share', context.data, function (result) {
      context.callback(result);
    });
  },

  /***
   * @description 打开外部浏览器
   * @param {object|string} context{
   *   data:{
   *     url:xxx //required
   *   }
   * }
   * @return {void} 无返回
   */
  openExternalBrowser: function openExternalBrowser(context) {
    if (!context) {
      var e = new Error("param context is required .....");
      throw e;
    }
    if ((0, _isObject3.default)(context)) {
      _util.util.checker(context);
    }
    _util.util.getDsBridge().call('openExternalBrowser', (0, _isString3.default)(context) ? context : context.data.url);
  },

  /***
   * @description nio app 中定制的输入组件
   * @param {object|string|null} context{
   *   data:{
   *     content:xxx // 初始文字    non-required
   *     length: 11, number 内容长度  non-required
   *   } 
   *   non -requiredå
   * 
   * }
   * @return {void} 
   */
  openNioInputEdit: function openNioInputEdit(context) {
    var param = {};
    if (context === undefined) {
      param.content = "";
    } else if ((0, _isString3.default)(context)) {
      param.content = context;
    } else if ((0, _isObject3.default)(context)) {
      param = context.data;
    }

    _util.util.getDsBridge().call('showInputEdit', param, function (result) {
      if ((0, _isObject3.default)(context) && (0, _isFunction3.default)(context.callback)) {
        context.callback(result);
      }
    });
  },

  /***
   * @description h5 给native 发数据
   * @param {object} context {
   *   data:{
              key: "KtNotificationName",
              data: {
                subKey: "value"
              }
            }
    * }
   * @return {void} 
   */
  postNotificationFromHtmlToNative: function postNotificationFromHtmlToNative(context) {
    if ((0, _isObject3.default)(context)) {
      _util.util.checker(context);
    } else {
      var e = new Error("params need Object like this  {  data:{key: 'KtNotificationName',data: { subKey: 'value' } } }");
      throw e;
    }
    _util.util.getDsBridge().call("postNotificationFromHtmlToNative", context);
  },

  /**
   *@description  事件注册类调用
    @param {object} context{
       event:'',  // 参考constant 中事件类型ß
       data:{
          preventDefault:1 // 阻止默认处理， 0 ：不阻止
       }
       callback:function(){
       
       }
    }
    @return {void}
    */
  register: function register(context) {
    _util.util.checker(context);
    if ((0, _isObject3.default)(context.data)) {
      var info = {};
      try {
        info = _util.util.getDsBridge().call('getCurrentPageInfo', '')['data'];
      } catch (ex) {
        console.error(ex);
      }
      _storage2.default.set({
        data: {
          key: info.objectId + '_' + context.event,
          value: context.data
        }
      });
    }
    _util.util.getDsBridge().register(context.event, function (result) {
      context.callback(result);
    });
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(18), __esModule: true };

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(1);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(20);

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(21);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(22);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(23),
    isObject = __webpack_require__(2),
    isSymbol = __webpack_require__(25);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(24);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _freeze = __webpack_require__(29);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description 项目使用的常量
 * @author  lei.you
 */
var constant = {
  TOAST: {
    LENGTH: 'LENGTH',
    SHORT: 'SHORT'
  },
  SWITCH: {
    ENABLE: '1',
    DISABLE: '0'
  },
  /**
   * @param {
   * ON_PRESS_BACK // 点击回退按钮
   * ON_APPEAR  // 切换页面
   * ON_NET_WORK_CHANGE // 网络状态变化
   * ON_PULL_REFRESH // 下拉刷新通知 
   * ON_SELF_DEFINE_EVENT_FOR_HEAD   //  自定义头部注册按钮的回调
   * ON_INPUT_KEYBROAD_CHANGE   // nio 定制输入组件弹出回调
   * ON_KEYBOARD_STATE_CHANGE // 软键盘弹出收起状态通知
   * }
   */
  EVENT: {
    ON_PRESS_BACK: 'ON_PRESS_BACK',
    ON_APPEAR: 'ON_APPEAR',
    ON_NET_WORK_CHANGE: 'ON_NET_WORK_CHANGE',
    ON_PULL_REFRESH: 'ON_PULL_REFRESH',
    ON_SELF_DEFINE_EVENT_FOR_HEAD: 'ON_SELF_DEFINE_EVENT_FOR_HEAD',
    ON_INPUT_KEYBROAD_CHANGE: 'ON_INPUT_KEYBROAD_CHANGE',
    ON_KEYBOARD_STATE_CHANGE: 'ON_KEYBOARD_STATE_CHANGE'
  }
};
(0, _freeze2.default)(constant);
exports.default = {
  constant: constant
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(30), __esModule: true };

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(31);
module.exports = __webpack_require__(1).Object.freeze;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(0);
var meta = __webpack_require__(32).onFreeze;

__webpack_require__(38)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(33)('meta');
var isObject = __webpack_require__(0);
var has = __webpack_require__(12);
var setDesc = __webpack_require__(13).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(3)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(0);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(5) && !__webpack_require__(3)(function () {
  return Object.defineProperty(__webpack_require__(36)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(0);
var document = __webpack_require__(14).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(0);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(39);
var core = __webpack_require__(1);
var fails = __webpack_require__(3);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(14);
var core = __webpack_require__(1);
var ctx = __webpack_require__(40);
var hide = __webpack_require__(42);
var has = __webpack_require__(12);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(41);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(13);
var createDesc = __webpack_require__(43);
module.exports = __webpack_require__(5) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ })
/******/ ]);
});